export default (name, url = window.location.href) => {
  const parameter_name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${parameter_name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) { return null; }
  if (!results[2]) { return ''; }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};